import { useSelector } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import ErrorComponent from "./Components/ErrorPage/ErrorComponent";
import PublicRoute from "./Routes/PublicRoutes";
import Layout from "./Layouts/Public/Layout";
import PrivateLayout from "./Layouts/Private/PrivateLayout";
import { ProtectedOutlet, PublicOutlet } from "./ProtectedRoutes";
import Login from "./Pages/Public/Login/Login";
// import DynamicPage from "./Pages/Public/DynamicPage/DynamicPage";
import ResetPassword from "./Pages/Public/ResetPassword/ResetPassword";
import ForgotPassword from "./Pages/Public/ForgotPassword/ForgotPassword";
import Submission from "./Pages/Public/Submission/Submission";
import CreatePassword from "./Pages/Public/Create-Password/CreatePassword";
import Sidebar from "./Components/Sidebar/Sidebar";
import PublicHeader from "./Components/PublicHeader/PublicHeader";
import Profiledetail from "./Components/Profile/Profile Details/Profiledetail";
import Editprofile from "./Components/Profile/Edit Profile/Editprofile";
import Changepw from "./Components/Profile/Change Password/Changepw";
import Loader from "./Components/Loader/Loader";
import { getRoutesByRole } from "./Utils/getRoutesByRole/getRoutesByRole";
import PrivacyPageDetail from "./Components/PrivacyPolicy/PrivacyPolicy";
import SupportPageDetail from "./Components/support/support";
import AboutPageDetail from "./Components/about/about"
// import Layout from "./Layouts/Public/Layout";
function App() {
  const loggedInUserRole = useSelector((state) => state?.auth?.user?.data?.body?.data?.role_name);

  const routesConfig = createBrowserRouter([
    {
      path: "/",
      element: <PublicOutlet />,
      errorElement: <ErrorComponent />,
      children: [
        {
          children: [
            {
              path: "/",
              element: <Login />,
            },

            {
              path: "/forgot-password",
              element: <ForgotPassword />,
            },
            {
              path: "/reset-password",
              element: <ResetPassword />,
            },
            {
              path: "/create-password",
              element: <CreatePassword />,
            },
            {
              path: "/sidebar",
              element: <Sidebar />,
            },
            {
              path: "/header",
              element: <PublicHeader />,
            },

            {
              path: "/layout",
              element: <Layout />,
            },
            {
              path: "/profile-detail",
              element: <Profiledetail />,
            },
            {
              path: "/edit-profile",
              element: <Editprofile />,
            },
            {
              path: "/change-password",
              element: <Changepw />,
            },
            {
              path: "/privacy",
              element: <PrivacyPageDetail />,
            },
            {
              path: "/support",
              element: <SupportPageDetail />,
            },
            {
              path: "/about",
              element: <AboutPageDetail />,
            },
          ],
        },
      ],
    },
    {
      path: "/",
      element: <PublicOutlet />,
      errorElement: <ErrorComponent />,
      children: [
        {
          children: [

            {
              path: "/submission",
              element: <Submission />,
            },
          ],
        },
      ],
    },
    {
      path: "/",
      element: <PublicOutlet />,
      errorElement: <ErrorComponent />,
      children: [
        {
          element: <Layout />,
          children: PublicRoute,
        },
      ],
    },
    {
      path: "/",
      element: <ProtectedOutlet />,
      errorElement: <ErrorComponent />,
      children: [
        {
          element: <PrivateLayout />,
          children:
            getRoutesByRole(loggedInUserRole)
        },
      ],
    },
  ]);

  return (
    <>
      <Loader />
      <RouterProvider router={routesConfig} />
      <ToastContainer />
    </>
  );
}

export default App;
